export class AppConstants {
  static readonly OutstandingBalancePage: string = 'outstandingbalance';
  static readonly ServiceChargeHistoryPage: string = 'servicechargehistory';
  static readonly ServiceItemChargePage: string = 'serviceitemcharge';
  static readonly LedgerPage: string = 'ledger';
}
